<div class="row" *ngIf="topPerforming">
  <div class="col-md-12 col-sm-12">
    <div class="d-flex flex-row top-influencer-name" (click)="openInfluencerDetails()">
      {{index + '. ' + topPerforming.influencerName}}
      <div class="flag-icon-background flag-icon-{{countryCode}} flag-icon-squared img-circle country-icon"></div>
    </div>
    <a class="top-performing-picture" (click)="openInfluencerDetails()">
      <blurry-backdrop-image [image]="topPerforming.influencerImage" (afterLoaded)="onLoadedImage()" (error)="onLoadedImage()"></blurry-backdrop-image>
    </a>
  </div>
  <div class="col-md-12 col-sm-12">
    <div class="d-flex flex-row align-items-center mentions-line top-performing-title">
      <div><span>{{'measure.best_performing.header.mentions' | translate}}</span></div>
      <div class="d-flex flex-auto top-performing-kpi-value"></div>
      <div><span>{{topPerforming.mention | thousandNumberSuffix}}</span></div>
    </div>
  </div>
  <div *ngIf="isSortedByReach" class="col-md-12 col-sm-12">
    <div class="d-flex flex-row align-items-center top-performing-title">
      <div><span>{{'measure.best_performing.header.reach' | translate}}</span></div>
      <div class="d-flex flex-auto top-performing-kpi-value"></div>
      <div><span>{{topPerforming.reach | thousandNumberSuffix}}</span></div>
    </div>
  </div>
  <div *ngIf="!isSortedByReach" class="col-md-12 col-sm-12">
    <div class="d-flex flex-row align-items-center top-performing-title">
      <div><span>{{'measure.best_performing.header.engagement' | translate}}</span></div>
      <div class="d-flex flex-auto top-performing-kpi-value"></div>
      <div><span>{{topPerforming.engagement | thousandNumberSuffix}}</span></div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12">
    <div class="d-flex flex-row align-items-center top-performing-title">
      <div><span>{{'measure.best_performing.header.impact' | translate}}</span></div>
      <div class="d-flex flex-auto top-performing-kpi-value"></div>
      <div><span>{{getImpactValue(topPerforming.impact) | percentNumberSuffix}}</span></div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/best-performing-influencer/top-performing-influencer/top-performing-influencer.component.html